import { render, staticRenderFns } from "./SectionCardNews.vue?vue&type=template&id=54a843a1&scoped=true&"
import script from "./SectionCardNews.vue?vue&type=script&lang=ts&"
export * from "./SectionCardNews.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCardNews.vue?vue&type=style&index=0&id=54a843a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a843a1",
  null
  
)

export default component.exports